import { __decorate } from "tslib";
import fetchFromCache from '@/utilities/fetchFromCache';
import { Module, VuexModule, MutationAction } from 'vuex-module-decorators';
let EnhancedItems = class EnhancedItems extends VuexModule {
    constructor() {
        super(...arguments);
        this.enhancedItems = [];
        this.cachedVersion = 0;
    }
    async fetchEnhancedItems() {
        const { data: enhancedItems, cachedVersion } = await fetchFromCache(this, 'enhancedItems', 'enhancedItem');
        return { enhancedItems, cachedVersion };
    }
};
__decorate([
    MutationAction({ mutate: ['enhancedItems', 'cachedVersion'] })
], EnhancedItems.prototype, "fetchEnhancedItems", null);
EnhancedItems = __decorate([
    Module({ namespaced: true, name: 'enhancedItems' })
], EnhancedItems);
export default EnhancedItems;
